import subject from "../topics/Topicts";

const subjects = [
  {
    id: 1,
    subject: 'Mathematics',
    name: 'Mathematics',
    icon: '📐',
    color: '#3498db',
  },
  {
    id: 2,
    subject: 'Reasoning',
    name: 'Reasoning',
    icon: '🧠',
    color: '#2ecc71',
  },
  {
    id: 3,
    subject: 'English',
    name: 'English',
    icon: '📖',
    color: '#9b59b6',
  },
  {
    id: 4,
    subject: 'General Knowledge',
    name: 'General Knowledge',
    icon: '🌍',
    color: '#f39c12',
  }
];

export default subjects;